import { useEffect, useState } from "react";
import { X } from "lucide-react";

export function Lightbox({ src, alt, onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    const prevOverflow = document.body.style.overflow;
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);
  return (
    <div className="fixed inset-0 z-[100] bg-slate-950/95 backdrop-blur-sm flex items-center justify-center p-4 sm:p-10"
      onClick={onClose} data-testid="screenshot-lightbox">
      <button type="button" data-testid="lightbox-close" aria-label="Close" onClick={(e) => { e.stopPropagation(); onClose(); }}
        className="absolute top-4 right-4 p-2 rounded-full bg-slate-800 hover:bg-slate-700 text-white transition-colors">
        <X className="h-5 w-5" />
      </button>
      <img src={src} alt={alt} onClick={(e) => e.stopPropagation()}
        className="max-h-full max-w-full rounded-xl border border-slate-700 shadow-2xl object-contain" />
    </div>
  );
}

export default function Screenshot({ src, alt, testid, className = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" data-testid={testid} onClick={() => setOpen(true)}
        className="block w-full cursor-zoom-in relative group">
        <img src={src} alt={alt} loading="lazy" className={className} />
        <span className="absolute bottom-2 right-2 px-2 py-1 rounded-md bg-slate-950/80 text-[10px] font-bold text-slate-300 opacity-0 group-hover:opacity-100 transition-opacity">
          Click to enlarge</span>
      </button>
      {open && <Lightbox src={src} alt={alt} onClose={() => setOpen(false)} />}
    </>
  );
}

export function BrowserFrame({ url = "app.fieldistry.com", children }) {
  return (
    <div className="rounded-xl border border-slate-700 bg-slate-900 shadow-2xl overflow-hidden" data-testid="browser-frame">
      <div className="flex items-center gap-1.5 px-3 py-2 bg-slate-800/80 border-b border-slate-700">
        <span className="h-2.5 w-2.5 rounded-full bg-rose-500/80" />
        <span className="h-2.5 w-2.5 rounded-full bg-amber-500/80" />
        <span className="h-2.5 w-2.5 rounded-full bg-emerald-500/80" />
        <span className="ml-2 flex-1 truncate rounded-md bg-slate-900 px-2 py-0.5 text-[10px] text-slate-500 font-mono">{url}</span>
      </div>
      {children}
    </div>
  );
}

export function PhoneFrame({ children }) {
  return (
    <div className="rounded-[1.8rem] border-4 border-slate-700 bg-slate-900 shadow-2xl overflow-hidden" data-testid="phone-frame">
      <div className="flex justify-center py-1.5 bg-slate-800">
        <span className="h-1 w-12 rounded-full bg-slate-600" />
      </div>
      {children}
    </div>
  );
}
